export default __webpack_public_path__ + "images/fedb6e7fc1adcd556f4157f229f3ff8a.png";